import { usePage } from "@inertiajs/react"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import type { PageProps } from "@/types/inertia"

type ArmedIndicatorProps = {
  compact?: boolean
}

export function ArmedIndicator({ compact = false }: ArmedIndicatorProps) {
  const { props } = usePage<PageProps>()
  const agency = props.agency

  if (!agency) return null

  const armed = agency.actions_armed
  const label = armed ? "ARMED · live actions" : "DISARMED · dry-run only"

  if (compact) {
    return (
      <div className="group/armed-indicator relative flex justify-center">
        <span
          className={cn(
            "h-3 w-3 rounded-full ring-2 ring-page",
            armed ? "bg-danger" : "bg-signal",
          )}
          aria-label={label}
        />
        <span
          role="tooltip"
          className="pointer-events-none absolute left-full top-1/2 z-50 ml-[13px] -translate-y-1/2 whitespace-nowrap rounded-md border border-hairline bg-page px-2 py-1 text-xs font-medium text-ink-display opacity-0 shadow-sm transition-opacity group-hover/armed-indicator:opacity-100"
        >
          {label}
        </span>
      </div>
    )
  }

  return (
    <Badge
      tone={armed ? "neutral" : "signal"}
      className={cn(
        "w-full justify-center uppercase",
        armed && "border-danger bg-danger-faded text-danger-display",
      )}
    >
      {label}
    </Badge>
  )
}
